import { BiometricStatus } from '@models/biometric';
import * as NativeUtils from '@utils/nativeUtils';

import useNativeListener from './useNativeListener';

interface Props {
    onSuccess: () => void;
    onError?: (result: Exclude<BiometricStatus, 'success'>) => void;
}

function useRegisterPin({ onSuccess, onError }: Props) {
    useNativeListener('registerBiometricPin', (result: { status: BiometricStatus; }) => {
        const { status } = result;
        if (status === 'success') {
            onSuccess();
        } else {
            onError?.(status);
        }
    }, [onSuccess, onError]);

    const registerPin = (pin: string) => {
        NativeUtils.registerPin(pin);
    };

    return {
        registerPin,
    };
}

export default useRegisterPin;
